import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import settings from './settingsReducer';
import user from './userReducer';
import auth from './authReducer';

const reducers = (history) => combineReducers({
  settings,
  user,
  auth,
  router: connectRouter(history),
});

export default reducers;
